import { render, staticRenderFns } from "./ApprReferSet.vue?vue&type=template&id=36e18678&scoped=true"
import script from "./ApprReferSet.vue?vue&type=script&lang=js"
export * from "./ApprReferSet.vue?vue&type=script&lang=js"
import style0 from "./ApprReferSet.vue?vue&type=style&index=0&id=36e18678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e18678",
  null
  
)

export default component.exports